// Auto-linkify URLs in chat message bodies so meeting links are clickable.
const URL_RE = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
const URL_TEST = /^(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)$/i;

export default function MessageBody({ text = "" }) {
  if (!text) return null;
  const parts = text.split(URL_RE);
  return (
    <>
      {parts.map((p, i) => {
        if (!p) return null;
        if (URL_TEST.test(p)) {
          const href = p.startsWith("http") ? p : `https://${p}`;
          return (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-mindora-red break-all hover:opacity-80"
            >
              {p}
            </a>
          );
        }
        return <span key={i}>{p}</span>;
      })}
    </>
  );
}
